<template>
  <div class="account" :class="{ 'primary-card': isPrimary }">
    <template v-if="!loading">
      <div class="top-data">
        <div @click="onPropsClick">
          <svg
            v-if="!sourceUrl"
            :class="isActive ? '' : 'gray-scale'"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#e00b5b" fill-opacity="0.06" />
            <mask id="path-2-inside-1" fill="white">
              <path
                d="M22.1283 12.0372C22.2836 12.0372 22.4095 11.904 22.4095 11.7396C22.4095 11.5751 22.2836 11.4419 22.1283 11.4419H18.8506C18.6952 11.4419 18.5693 11.5751 18.5693 11.7396C18.5693 11.904 18.6952 12.0372 18.8506 12.0372H22.1283Z"
              />
            </mask>
            <path
              d="M22.1283 13.2372C23.0096 13.2372 23.6095 12.5017 23.6095 11.7396H21.2095C21.2095 11.3063 21.5577 10.8372 22.1283 10.8372V13.2372ZM23.6095 11.7396C23.6095 10.9774 23.0096 10.2419 22.1283 10.2419V12.6419C21.5577 12.6419 21.2095 12.1728 21.2095 11.7396H23.6095ZM22.1283 10.2419H18.8506V12.6419H22.1283V10.2419ZM18.8506 10.2419C17.9693 10.2419 17.3693 10.9774 17.3693 11.7396H19.7693C19.7693 12.1728 19.4212 12.6419 18.8506 12.6419V10.2419ZM17.3693 11.7396C17.3693 12.5017 17.9693 13.2372 18.8506 13.2372V10.8372C19.4212 10.8372 19.7693 11.3063 19.7693 11.7396H17.3693ZM18.8506 13.2372H22.1283V10.8372H18.8506V13.2372Z"
              fill="#e00b5b"
              mask="url(#path-2-inside-1)"
            />
            <mask id="path-4-inside-2" fill="white">
              <path
                d="M17.4443 13.1922C17.4443 13.3566 17.5703 13.4898 17.7256 13.4898H22.1283C22.2836 13.4898 22.4095 13.3566 22.4095 13.1922C22.4095 13.0278 22.2836 12.8945 22.1283 12.8945H17.7256C17.5703 12.8945 17.4443 13.0278 17.4443 13.1922Z"
              />
            </mask>
            <path
              d="M16.2443 13.1922C16.2443 13.9544 16.8444 14.6898 17.7256 14.6898V12.2898C18.2961 12.2898 18.6443 12.7588 18.6443 13.1922H16.2443ZM17.7256 14.6898H22.1283V12.2898H17.7256V14.6898ZM22.1283 14.6898C23.0096 14.6898 23.6095 13.9543 23.6095 13.1922H21.2095C21.2095 12.7589 21.5577 12.2898 22.1283 12.2898V14.6898ZM23.6095 13.1922C23.6095 12.43 23.0096 11.6945 22.1283 11.6945V14.0945C21.5577 14.0945 21.2095 13.6255 21.2095 13.1922H23.6095ZM22.1283 11.6945H17.7256V14.0945H22.1283V11.6945ZM17.7256 11.6945C16.8444 11.6945 16.2443 12.4299 16.2443 13.1922H18.6443C18.6443 13.6256 18.2961 14.0945 17.7256 14.0945V11.6945Z"
              fill="#e00b5b"
              mask="url(#path-4-inside-2)"
            />
            <mask id="path-6-inside-3" fill="white">
              <path
                d="M17.7256 14.9422H22.1283C22.2836 14.9422 22.4095 14.809 22.4095 14.6446C22.4095 14.4802 22.2836 14.3469 22.1283 14.3469H17.7256C17.5703 14.3469 17.4443 14.4802 17.4443 14.6446C17.4443 14.809 17.5703 14.9422 17.7256 14.9422Z"
              />
            </mask>
            <path
              d="M17.7256 16.1422H22.1283V13.7422H17.7256V16.1422ZM22.1283 16.1422C23.0096 16.1422 23.6095 15.4067 23.6095 14.6446H21.2095C21.2095 14.2113 21.5577 13.7422 22.1283 13.7422V16.1422ZM23.6095 14.6446C23.6095 13.8824 23.0096 13.1469 22.1283 13.1469V15.5469C21.5577 15.5469 21.2095 15.0779 21.2095 14.6446H23.6095ZM22.1283 13.1469H17.7256V15.5469H22.1283V13.1469ZM17.7256 13.1469C16.8444 13.1469 16.2443 13.8823 16.2443 14.6446H18.6443C18.6443 15.078 18.2961 15.5469 17.7256 15.5469V13.1469ZM16.2443 14.6446C16.2443 15.4068 16.8444 16.1422 17.7256 16.1422V13.7422C18.2961 13.7422 18.6443 14.2112 18.6443 14.6446H16.2443Z"
              fill="#e00b5b"
              mask="url(#path-6-inside-3)"
            />
            <mask id="path-8-inside-4" fill="white">
              <path
                d="M13.4337 20.7043C13.1649 20.7043 12.9463 20.9357 12.9463 21.2201V24.0642C12.9463 24.3486 13.1649 24.58 13.4337 24.58H15.187C15.4557 24.58 15.6743 24.3486 15.6743 24.0642V21.2201C15.6743 20.9357 15.4557 20.7043 15.187 20.7043H13.4337ZM15.1118 23.9847H13.5088V21.2997H15.1118V23.9847Z"
              />
            </mask>
            <path
              d="M15.1118 23.9847V25.1847H16.3118V23.9847H15.1118ZM13.5088 23.9847H12.3088V25.1847H13.5088V23.9847ZM13.5088 21.2997V20.0997H12.3088V21.2997H13.5088ZM15.1118 21.2997H16.3118V20.0997H15.1118V21.2997ZM13.4337 19.5043C12.439 19.5043 11.7463 20.3379 11.7463 21.2201H14.1463C14.1463 21.5335 13.8908 21.9043 13.4337 21.9043V19.5043ZM11.7463 21.2201V24.0642H14.1463V21.2201H11.7463ZM11.7463 24.0642C11.7463 24.9464 12.439 25.78 13.4337 25.78V23.38C13.8908 23.38 14.1463 23.7508 14.1463 24.0642H11.7463ZM13.4337 25.78H15.187V23.38H13.4337V25.78ZM15.187 25.78C16.1816 25.78 16.8743 24.9463 16.8743 24.0642H14.4743C14.4743 23.7509 14.7297 23.38 15.187 23.38V25.78ZM16.8743 24.0642V21.2201H14.4743V24.0642H16.8743ZM16.8743 21.2201C16.8743 20.338 16.1816 19.5043 15.187 19.5043V21.9043C14.7297 21.9043 14.4743 21.5334 14.4743 21.2201H16.8743ZM15.187 19.5043H13.4337V21.9043H15.187V19.5043ZM15.1118 22.7847H13.5088V25.1847H15.1118V22.7847ZM14.7088 23.9847V21.2997H12.3088V23.9847H14.7088ZM13.5088 22.4997H15.1118V20.0997H13.5088V22.4997ZM13.9118 21.2997V23.9847H16.3118V21.2997H13.9118Z"
              fill="#e00b5b"
              mask="url(#path-8-inside-4)"
            />
            <mask id="path-10-inside-5" fill="white">
              <path
                d="M16.6357 20.4264V24.0643C16.6357 24.3487 16.8544 24.58 17.1231 24.58H18.8764C19.1451 24.58 19.3638 24.3487 19.3638 24.0643V20.4264C19.3638 20.142 19.1451 19.9106 18.8764 19.9106H17.1231C16.8544 19.9106 16.6357 20.142 16.6357 20.4264ZM17.1982 20.506H18.8013V23.9847H17.1982V20.506Z"
              />
            </mask>
            <path
              d="M17.1982 20.506V19.306H15.9982V20.506H17.1982ZM18.8013 20.506H20.0013V19.306H18.8013V20.506ZM18.8013 23.9847V25.1847H20.0013V23.9847H18.8013ZM17.1982 23.9847H15.9982V25.1847H17.1982V23.9847ZM15.4357 20.4264V24.0643H17.8357V20.4264H15.4357ZM15.4357 24.0643C15.4357 24.9464 16.1284 25.78 17.1231 25.78V23.38C17.5803 23.38 17.8357 23.7509 17.8357 24.0643H15.4357ZM17.1231 25.78H18.8764V23.38H17.1231V25.78ZM18.8764 25.78C19.8711 25.78 20.5638 24.9464 20.5638 24.0643H18.1638C18.1638 23.7509 18.4192 23.38 18.8764 23.38V25.78ZM20.5638 24.0643V20.4264H18.1638V24.0643H20.5638ZM20.5638 20.4264C20.5638 19.5443 19.8711 18.7106 18.8764 18.7106V21.1106C18.4192 21.1106 18.1638 20.7397 18.1638 20.4264H20.5638ZM18.8764 18.7106H17.1231V21.1106H18.8764V18.7106ZM17.1231 18.7106C16.1285 18.7106 15.4357 19.5442 15.4357 20.4264H17.8357C17.8357 20.7398 17.5803 21.1106 17.1231 21.1106V18.7106ZM17.1982 21.706H18.8013V19.306H17.1982V21.706ZM17.6013 20.506V23.9847H20.0013V20.506H17.6013ZM18.8013 22.7847H17.1982V25.1847H18.8013V22.7847ZM18.3982 23.9847V20.506H15.9982V23.9847H18.3982Z"
              fill="#e00b5b"
              mask="url(#path-10-inside-5)"
            />
            <mask id="path-12-inside-6" fill="white">
              <path
                d="M26.9729 20.021C26.9903 19.954 27.0004 19.8838 27.0004 19.811V19.2435C27.0004 18.8769 26.764 18.5685 26.4443 18.4777C26.4645 18.4059 26.4758 18.3301 26.4758 18.2515V17.684C26.4758 17.6053 26.4645 17.5295 26.4443 17.4577C26.764 17.3669 27.0004 17.0584 27.0004 16.6918V16.1244C27.0004 15.6868 26.6639 15.3307 26.2504 15.3307H24.5176V10.2186C24.5176 9.87756 24.2554 9.6001 23.9332 9.6001H16.1128C15.9575 9.6001 15.8315 9.73333 15.8315 9.89776C15.8315 10.0622 15.9575 10.1954 16.1128 10.1954H23.9332C23.9452 10.1954 23.9551 10.2058 23.9551 10.2186V25.7816C23.9551 25.7944 23.9452 25.8048 23.9332 25.8048H12.0667C12.0546 25.8048 12.0448 25.7944 12.0448 25.7816C12.0448 24.0868 12.0448 11.9806 12.0448 10.2186C12.0448 10.2058 12.0546 10.1954 12.0667 10.1954H14.9883C15.1436 10.1954 15.2695 10.0622 15.2695 9.89776C15.2695 9.73333 15.1436 9.6001 14.9883 9.6001H12.0667C11.7444 9.6001 11.4823 9.87756 11.4823 10.2186V16.8903H9.74941C9.3359 16.8903 8.99945 17.2464 8.99945 17.684V18.2515C8.99945 18.3243 9.00954 18.3945 9.02694 18.4615C8.67181 18.5238 8.3999 18.8503 8.3999 19.2435V19.811C8.3999 20.2043 8.67181 20.5307 9.02694 20.5931C9.0095 20.6601 8.99945 20.7304 8.99945 20.8032V21.3706C8.99945 21.4434 9.00954 21.5136 9.02694 21.5806C8.67181 21.6429 8.3999 21.9694 8.3999 22.3626V22.9301C8.3999 23.1178 8.46208 23.2902 8.56531 23.4262C8.46208 23.5622 8.3999 23.7346 8.3999 23.9222V24.4897C8.3999 24.9274 8.73631 25.2834 9.14986 25.2834H9.59945C9.75478 25.2834 9.8807 25.1502 9.8807 24.9858C9.8807 24.8214 9.75478 24.6881 9.59945 24.6881H9.14986C9.04651 24.6881 8.9624 24.5991 8.9624 24.4897V23.9222C8.9624 23.8128 9.04648 23.7238 9.14986 23.7238H11.4823V24.6881H10.724C10.5687 24.6881 10.4428 24.8214 10.4428 24.9858C10.4428 25.1502 10.5687 25.2834 10.724 25.2834H11.4823V25.7816C11.4823 26.1226 11.7444 26.4001 12.0667 26.4001H23.9332C24.2554 26.4001 24.5176 26.1226 24.5176 25.7816V25.2834H26.2504C26.6639 25.2834 27.0004 24.9274 27.0004 24.4897V23.9222C27.0004 23.7346 26.9382 23.5622 26.8349 23.4262C26.9382 23.2902 27.0004 23.1178 27.0004 22.9301V22.3626C27.0004 22.2898 26.9903 22.2196 26.9729 22.1526C27.328 22.0902 27.5999 21.7638 27.5999 21.3705V20.803C27.5999 20.4099 27.328 20.0834 26.9729 20.021ZM9.56195 21.3706V20.8031C9.56195 20.6937 9.64606 20.6047 9.74941 20.6047H11.4822V21.569H9.74941C9.64603 21.569 9.56195 21.48 9.56195 21.3706ZM9.56195 17.684C9.56195 17.5745 9.64606 17.4856 9.74941 17.4856H11.4822V18.4498H9.74941C9.64606 18.4498 9.56195 18.3608 9.56195 18.2515V17.684ZM8.9624 19.811V19.2435C8.9624 19.1341 9.04648 19.0451 9.14986 19.0451H9.74941H11.4822V20.0094C10.9204 20.0094 9.70501 20.0094 9.14983 20.0094C9.04648 20.0094 8.9624 19.9204 8.9624 19.811ZM9.14986 23.1285C9.04651 23.1285 8.9624 23.0395 8.9624 22.9301V22.3626C8.9624 22.2533 9.04648 22.1643 9.14986 22.1643H11.4823V23.1285H9.14986ZM26.4379 22.3626V22.9301C26.4379 23.0395 26.3538 23.1285 26.2504 23.1285H24.5176V22.1643H26.2504C26.3538 22.1643 26.4379 22.2533 26.4379 22.3626ZM25.9133 17.684V18.2515C25.9133 18.3608 25.8292 18.4498 25.7258 18.4498H24.5176V17.4856H25.7258C25.8292 17.4856 25.9133 17.5746 25.9133 17.684ZM24.5176 19.0451H26.2504C26.3538 19.0451 26.4379 19.1341 26.4379 19.2435V19.811C26.4379 19.9204 26.3538 20.0094 26.2504 20.0094H24.5176V19.0451ZM26.2504 15.926C26.3538 15.926 26.4379 16.015 26.4379 16.1244V16.6918C26.4379 16.8013 26.3538 16.8903 26.2504 16.8903C25.9596 16.8903 24.9634 16.8903 24.5176 16.8903V15.926H26.2504ZM26.4379 24.4897C26.4379 24.5991 26.3538 24.6881 26.2504 24.6881H24.5176V23.7238H26.2504C26.3538 23.7238 26.4379 23.8128 26.4379 23.9222V24.4897ZM27.0374 21.3706C27.0374 21.48 26.9533 21.569 26.8499 21.569C26.297 21.569 25.0805 21.569 24.5176 21.569V20.6047H26.8499C26.9533 20.6047 27.0374 20.6937 27.0374 20.8031V21.3706Z"
              />
            </mask>
            <path
              d="M26.9729 20.021C26.9903 19.954 27.0004 19.8838 27.0004 19.811V19.2435C27.0004 18.8769 26.764 18.5685 26.4443 18.4777C26.4645 18.4059 26.4758 18.3301 26.4758 18.2515V17.684C26.4758 17.6053 26.4645 17.5295 26.4443 17.4577C26.764 17.3669 27.0004 17.0584 27.0004 16.6918V16.1244C27.0004 15.6868 26.6639 15.3307 26.2504 15.3307H24.5176V10.2186C24.5176 9.87756 24.2554 9.6001 23.9332 9.6001H16.1128C15.9575 9.6001 15.8315 9.73333 15.8315 9.89776C15.8315 10.0622 15.9575 10.1954 16.1128 10.1954H23.9332C23.9452 10.1954 23.9551 10.2058 23.9551 10.2186V25.7816C23.9551 25.7944 23.9452 25.8048 23.9332 25.8048H12.0667C12.0546 25.8048 12.0448 25.7944 12.0448 25.7816C12.0448 24.0868 12.0448 11.9806 12.0448 10.2186C12.0448 10.2058 12.0546 10.1954 12.0667 10.1954H14.9883C15.1436 10.1954 15.2695 10.0622 15.2695 9.89776C15.2695 9.73333 15.1436 9.6001 14.9883 9.6001H12.0667C11.7444 9.6001 11.4823 9.87756 11.4823 10.2186V16.8903H9.74941C9.3359 16.8903 8.99945 17.2464 8.99945 17.684V18.2515C8.99945 18.3243 9.00954 18.3945 9.02694 18.4615C8.67181 18.5238 8.3999 18.8503 8.3999 19.2435V19.811C8.3999 20.2043 8.67181 20.5307 9.02694 20.5931C9.0095 20.6601 8.99945 20.7304 8.99945 20.8032V21.3706C8.99945 21.4434 9.00954 21.5136 9.02694 21.5806C8.67181 21.6429 8.3999 21.9694 8.3999 22.3626V22.9301C8.3999 23.1178 8.46208 23.2902 8.56531 23.4262C8.46208 23.5622 8.3999 23.7346 8.3999 23.9222V24.4897C8.3999 24.9274 8.73631 25.2834 9.14986 25.2834H9.59945C9.75478 25.2834 9.8807 25.1502 9.8807 24.9858C9.8807 24.8214 9.75478 24.6881 9.59945 24.6881H9.14986C9.04651 24.6881 8.9624 24.5991 8.9624 24.4897V23.9222C8.9624 23.8128 9.04648 23.7238 9.14986 23.7238H11.4823V24.6881H10.724C10.5687 24.6881 10.4428 24.8214 10.4428 24.9858C10.4428 25.1502 10.5687 25.2834 10.724 25.2834H11.4823V25.7816C11.4823 26.1226 11.7444 26.4001 12.0667 26.4001H23.9332C24.2554 26.4001 24.5176 26.1226 24.5176 25.7816V25.2834H26.2504C26.6639 25.2834 27.0004 24.9274 27.0004 24.4897V23.9222C27.0004 23.7346 26.9382 23.5622 26.8349 23.4262C26.9382 23.2902 27.0004 23.1178 27.0004 22.9301V22.3626C27.0004 22.2898 26.9903 22.2196 26.9729 22.1526C27.328 22.0902 27.5999 21.7638 27.5999 21.3705V20.803C27.5999 20.4099 27.328 20.0834 26.9729 20.021ZM9.56195 21.3706V20.8031C9.56195 20.6937 9.64606 20.6047 9.74941 20.6047H11.4822V21.569H9.74941C9.64603 21.569 9.56195 21.48 9.56195 21.3706ZM9.56195 17.684C9.56195 17.5745 9.64606 17.4856 9.74941 17.4856H11.4822V18.4498H9.74941C9.64606 18.4498 9.56195 18.3608 9.56195 18.2515V17.684ZM8.9624 19.811V19.2435C8.9624 19.1341 9.04648 19.0451 9.14986 19.0451H9.74941H11.4822V20.0094C10.9204 20.0094 9.70501 20.0094 9.14983 20.0094C9.04648 20.0094 8.9624 19.9204 8.9624 19.811ZM9.14986 23.1285C9.04651 23.1285 8.9624 23.0395 8.9624 22.9301V22.3626C8.9624 22.2533 9.04648 22.1643 9.14986 22.1643H11.4823V23.1285H9.14986ZM26.4379 22.3626V22.9301C26.4379 23.0395 26.3538 23.1285 26.2504 23.1285H24.5176V22.1643H26.2504C26.3538 22.1643 26.4379 22.2533 26.4379 22.3626ZM25.9133 17.684V18.2515C25.9133 18.3608 25.8292 18.4498 25.7258 18.4498H24.5176V17.4856H25.7258C25.8292 17.4856 25.9133 17.5746 25.9133 17.684ZM24.5176 19.0451H26.2504C26.3538 19.0451 26.4379 19.1341 26.4379 19.2435V19.811C26.4379 19.9204 26.3538 20.0094 26.2504 20.0094H24.5176V19.0451ZM26.2504 15.926C26.3538 15.926 26.4379 16.015 26.4379 16.1244V16.6918C26.4379 16.8013 26.3538 16.8903 26.2504 16.8903C25.9596 16.8903 24.9634 16.8903 24.5176 16.8903V15.926H26.2504ZM26.4379 24.4897C26.4379 24.5991 26.3538 24.6881 26.2504 24.6881H24.5176V23.7238H26.2504C26.3538 23.7238 26.4379 23.8128 26.4379 23.9222V24.4897ZM27.0374 21.3706C27.0374 21.48 26.9533 21.569 26.8499 21.569C26.297 21.569 25.0805 21.569 24.5176 21.569V20.6047H26.8499C26.9533 20.6047 27.0374 20.6937 27.0374 20.8031V21.3706Z"
              stroke="#e00b5b"
              stroke-width="2.4"
              mask="url(#path-12-inside-6)"
            />
            <mask id="path-13-inside-7" fill="white">
              <path
                d="M22.7724 21.9481C22.9278 21.9481 23.0537 21.8148 23.0537 21.6504V18.839C23.0537 18.5546 22.8351 18.3232 22.5663 18.3232H20.813C20.5443 18.3232 20.3257 18.5546 20.3257 18.839V24.0644C20.3257 24.3488 20.5443 24.5802 20.813 24.5802H22.5663C22.8351 24.5802 23.0537 24.3488 23.0537 24.0644V22.8405C23.0537 22.6761 22.9278 22.5429 22.7724 22.5429C22.6171 22.5429 22.4912 22.6761 22.4912 22.8405V23.9848H20.8882V18.9186H22.4912V21.6504C22.4912 21.8148 22.6171 21.9481 22.7724 21.9481Z"
              />
            </mask>
            <path
              d="M22.4912 23.9848V25.1848H23.6912V23.9848H22.4912ZM20.8882 23.9848H19.6882V25.1848H20.8882V23.9848ZM20.8882 18.9186V17.7186H19.6882V18.9186H20.8882ZM22.4912 18.9186H23.6912V17.7186H22.4912V18.9186ZM22.7724 23.1481C23.6538 23.1481 24.2537 22.4125 24.2537 21.6504H21.8537C21.8537 21.2171 22.2019 20.7481 22.7724 20.7481V23.1481ZM24.2537 21.6504V18.839H21.8537V21.6504H24.2537ZM24.2537 18.839C24.2537 17.9569 23.561 17.1232 22.5663 17.1232V19.5232C22.1091 19.5232 21.8537 19.1523 21.8537 18.839H24.2537ZM22.5663 17.1232H20.813V19.5232H22.5663V17.1232ZM20.813 17.1232C19.8184 17.1232 19.1257 17.9569 19.1257 18.839H21.5257C21.5257 19.1523 21.2703 19.5232 20.813 19.5232V17.1232ZM19.1257 18.839V24.0644H21.5257V18.839H19.1257ZM19.1257 24.0644C19.1257 24.9465 19.8184 25.7802 20.813 25.7802V23.3802C21.2703 23.3802 21.5257 23.7511 21.5257 24.0644H19.1257ZM20.813 25.7802H22.5663V23.3802H20.813V25.7802ZM22.5663 25.7802C23.561 25.7802 24.2537 24.9465 24.2537 24.0644H21.8537C21.8537 23.7511 22.1091 23.3802 22.5663 23.3802V25.7802ZM24.2537 24.0644V22.8405H21.8537V24.0644H24.2537ZM24.2537 22.8405C24.2537 22.0784 23.6538 21.3429 22.7724 21.3429V23.7429C22.2019 23.7429 21.8537 23.2738 21.8537 22.8405H24.2537ZM22.7724 21.3429C21.8911 21.3429 21.2912 22.0784 21.2912 22.8405H23.6912C23.6912 23.2738 23.343 23.7429 22.7724 23.7429V21.3429ZM21.2912 22.8405V23.9848H23.6912V22.8405H21.2912ZM22.4912 22.7848H20.8882V25.1848H22.4912V22.7848ZM22.0882 23.9848V18.9186H19.6882V23.9848H22.0882ZM20.8882 20.1186H22.4912V17.7186H20.8882V20.1186ZM21.2912 18.9186V21.6504H23.6912V18.9186H21.2912ZM21.2912 21.6504C21.2912 22.4125 21.8912 23.1481 22.7724 23.1481V20.7481C23.3431 20.7481 23.6912 21.2171 23.6912 21.6504H21.2912Z"
              fill="#e00b5b"
              mask="url(#path-13-inside-7)"
            />
          </svg>
          <img
            v-else
            :src="sourceUrl"
            :class="isActive ? '' : 'gray-scale'"
            class="image-"
          />
        </div>
        <div>
          <b-dropdown
            v-if="dropdown"
            right
            size="sm"
            toggle-class="drop-down-text-decoration-none __btn"
            menu-class="act__menu"
            no-caret
            :split="false"
          >
            <template #button-content>
              <svg
                width="4"
                height="16"
                viewBox="0 0 4 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="2" cy="2" r="2" fill="#919EAB" fill-opacity="0.6" />
                <circle cx="2" cy="8" r="2" fill="#919EAB" fill-opacity="0.6" />
                <circle
                  cx="2"
                  cy="14"
                  r="2"
                  fill="#919EAB"
                  fill-opacity="0.6"
                />
              </svg>
            </template>
            <div style="z-index: 10">
              <slot name="dropdown"></slot>
            </div>
          </b-dropdown>
        </div>
      </div>

      <div @click="onPropsClick">
        <div
          class="account__a-title"
          :title="
            useNameTooltip
              ? startCase((name || '').toLowerCase()) +
                (account ? `(${account})` : '')
              : ''
          "
          v-b-tooltip.hover.top
        >
          <div style="display: flex; width: 100%">
            <div
              class="truncate"
              style="max-width: 90% !important"
              v-if="!account"
            >
              {{ startCase((name || "").toLowerCase()) }}
            </div>
            <div
              class="truncate"
              style="max-width: 70% !important"
              v-if="account"
            >
              {{ startCase((name || "").toLowerCase()) }}
            </div>
            <div style="display: inline-block; padding: 0 5px" v-if="account">
              {{ account }}
            </div>
            <span v-if="isPrimary" class="primary-badge">
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6.5" cy="6.5" r="6.5" fill="#e00b5b" />
                <path
                  d="M8.9375 4.875L5.58594 8.125L4.0625 6.64773"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </div>
        <div class="amount">
          <span>{{ amount }}</span>
          <template v-if="useActiveStatusIndicator">
            <img src="@/assets/active-account.svg" v-if="isActive" />
            <img src="@/assets/inactive-account.svg" v-else />
          </template>
        </div>
      </div>
    </template>

    <div v-else>
      <content-loader
        :width="476"
        :height="140"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="1" y="110" rx="4" ry="4" width="150" height="16" />
        <rect x="1" y="84" rx="4" ry="4" width="200" height="12" />
        <circle cx="32" cy="32" r="32" />
      </content-loader>
    </div>
  </div>
</template>
<script>
import startCase from "lodash/startCase";
import { ContentLoader } from "vue-content-loader";
export default {
  name: "AccountCard",
  components: { ContentLoader },
  props: {
    account: String,
    amount: String,
    name: String,
    loading: {
      type: Boolean,
      default: false,
    },
    sourceUrl: String,
    isActive: {
      type: Boolean,
      default: false,
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
    useNameTooltip: {
      type: Boolean,
      default: true,
    },
    useActiveStatusIndicator: {
      type: Boolean,
      default: true,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },

  model: {
    event: "click",
  },
  methods: {
    startCase: startCase,
    onPropsClick() {
      if (this.onClick) {
        this.onClick();
      }
      this.$emit("click", () => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.account {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  //border: 1px solid rgba(193, 202, 212, 0.7);
  box-sizing: border-box;
  padding: 24px;
  font-family: "Calibre";
  width: 332px;
  height: 160px;
  margin: 10px 20px 10px 1px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &:hover {
    border: 1px solid rgba(145, 158, 171, 0.7);
    opacity: 1;
  }
  &.primary-card {
    background: rgba(224, 11, 91, 0.03);
    border: 1px solid rgba(224, 11, 91, 0.2);
  }
  svg {
    cursor: pointer;
  }
  .act__item {
    font-family: Calibre !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 16px !important;
    color: #495255 !important;
    text-decoration: none !important;
    text-align: center !important;
    margin: 0 auto !important;
    display: flex !important;

    &.deactivate {
      color: #c61010 !important;
    }
    &.active {
      color: #2dc27c !important;
    }
    //justify-content: space-between;
    align-content: center;
    padding: 10px 20px !important;
    border: none !important;

    width: 100% !important;
    min-width: fit-content !important;
    white-space: nowrap !important;
    div {
      padding: 5px;
      padding-left: 10px;
    }
    &:hover {
      padding: 8px 15px !important;
    }
  }
  &__a-title {
    font-family: Calibre;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 14px;
    /* identical to box height, or 93% */
    color: rgba(38, 25, 64, 0.7);
    text-transform: capitalize;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .amount {
    cursor: pointer;
    font-family: "Calibre";
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 31px;
    color: #261940;

    display: flex;
    justify-content: space-between;
    align-content: center;
  }

  &.create {
    justify-content: center;
    align-items: center;
    border: 1px solid #e00b5b;
    background: #ffffff;
    font-family: "Calibre";
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 17px;
    color: rgba(255, 114, 118, 0.8);
    cursor: pointer;
    span {
      display: block;
      padding: 10px;
    }
  }
  .top-data {
    display: flex;
    justify-content: space-between;
  }
}

.gray-scale {
  filter: grayscale(100);
}
.image- {
  max-width: 130px !important;
  max-height: 30px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.primary-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(224, 11, 91, 0.1);
  border-radius: 50%;
  padding: 4px;
  margin-left: 4px;
}
</style>
